export default __webpack_public_path__ + "046120b19ccce4894edad5fc604af873.svg";